import React, { useMemo } from 'react';
import { Card, CardHeader, CardBody } from '../../../../../../../_metronic/_partials/controls';
import Moment from 'react-moment';

export function KurbanReportDetailComment({ commentData }) {

    return (
        <Card border="primary">
            <CardHeader title="Pesan Dari Admin"></CardHeader>
            <CardBody>

                <div className="card-body pt-4">
                    <div className="timeline timeline-6 mt-3">

                        {commentData.map(row =>
                            <div className="timeline-item align-items-start" key={row.uuid}>
                                <div className="timeline-label font-weight-bolder text-dark-75 font-size-lg">
                                    <Moment format="HH:mm">{row.created_at}</Moment>
                                </div>

                                <div className="timeline-badge">
                                    <i className="fa fa-genderless text-warning icon-xl"></i>
                                </div>

                                <div className="font-weight-mormal font-size-lg timeline-content text-muted pl-3">
                                    <span className="text-primary font-italic">{row.nickname}</span>,&nbsp;
                                    <span className="text-dark">
                                        <Moment format="DD-MM-YYYY">{row.created_at}</Moment>
                                    </span>
                                    <br />
                                    {row.message}
                                </div>
                            </div>
                        )}

                    </div>
                </div>

            </CardBody>
        </Card>

    );
}
